import { render, staticRenderFns } from "./ViewOpportunite.vue?vue&type=template&id=5eae856a&scoped=true&"
import script from "./ViewOpportunite.vue?vue&type=script&lang=ts&"
export * from "./ViewOpportunite.vue?vue&type=script&lang=ts&"
import style0 from "./ViewOpportunite.vue?vue&type=style&index=0&id=5eae856a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eae856a",
  null
  
)

export default component.exports